import { useIntl } from "react-intl";
import { BasicButton } from "../../widgets/components/UI/BasicButton";
import { useThemeMode } from "../../../../_metronic/partials";
import crossIcon from "../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg";
import { AttendanceType, MeetingType } from "../core/_constants";
import { useState } from "react";
import { getMeetingLists } from "../core/_requests";
import { Formik } from "formik";
import TextInput from "../../widgets/components/Input/TextInput";
import { SelectInput } from "../../widgets/components/Input/SelectInput";
import * as Yup from 'yup'
export const FilterMeeting = ({ filter, setFilter, setMeetingList, setMeetingTypes, setClear }: any) => {
    const { formatMessage } = useIntl();
    const { mode } = useThemeMode();
    const [filterLoading, setFilterLoading] = useState(false);
    const initialValues = {
        meetingType: '',
        attendance: '',
        date: '',
    }
    const userSchema = Yup.object().shape({
        meetingType: Yup.string().required('Please select meeting'),
        attendance: Yup.string()
            .nullable(),
        date: Yup.string()
            .nullable(),
    });
    const closeFilter = () => {
        setFilter(false);
    };

    const clearFilters = (formik: any) => {
        setMeetingTypes('');
        formik.resetForm();
        setClear(true);
        setFilter(false);

    };

    const onApplyFilter = async (values: any) => {
        setFilterLoading(true);
        await getMeetingList(values);
        setFilterLoading(false);
        setFilter(false)
        setClear(false)
    };

    const getMeetingList = async (values: any) => {
        try {
            const { data: { success, data } } = await getMeetingLists(values.meetingType, values.attendance, values.date);
            if (success) {
                setMeetingTypes(values.meetingType)
                setMeetingList(data.data.meetingList);
            }
        } catch (err) {
            console.error("Error fetching meetings:", err);
        }
    };
    return (
        <div
            className={
                filter ? "bg-body drawer drawer-end drawer-on" : "bg-body drawer drawer-end"
            }
            id="fc-filter"
            data-kt-drawer="true"
            data-kt-drawer-name="filter"
            data-kt-drawer-overlay="true"
            data-kt-drawer-activate="true"
            data-kt-drawer-width="{default:'300px', 'md': '400px'}"
            data-kt-drawer-direction="end"
        >
            {/* Card */}
            <div className="card shadow-none rounded-0 w-100">
                {/* Header */}
                <div className="card-header" id="fc_header">
                    <div className="card-toolbar gap-6">
                        <button
                            type="button"
                            className="btn btn-sm btn-icon explore-btn-dismiss me-n5"
                            onClick={closeFilter}
                        >
                            <img src={crossIcon} alt="Close" />
                        </button>
                        <h5 className="card-title fw-bold">{formatMessage({ id: "Sort or Filter" })}</h5>
                    </div>
                </div>
                {/* Body */}
                <Formik
                    initialValues={initialValues}
                    validationSchema={userSchema}
                    onSubmit={onApplyFilter}
                    validateOnMount
                    enableReinitialize
                >
                    {(formik: any) => {
                        console.log(formik);

                        return (
                            <>
                                <div className="card-body">
                                    {/* Clear All Filters */}
                                    <div className="mb-5">
                                        <BasicButton
                                            id="fc-clear"
                                            height="36px"
                                            border="none"
                                            color={mode === "dark" ? "#323248" : "#F5F8FA"}
                                            textColor={mode === "dark" ? "#FFFFFF" : "#585960"}
                                            padding="8px 16px"
                                            buttonText={formatMessage({ id: "Clear All filters" })}
                                            minWidth={125}
                                            onClick={() => clearFilters(formik)}
                                        />
                                    </div>
                                    <SelectInput
                                        label={formatMessage({ id: 'By Meeting Type' })}
                                        fieldName='meetingType'
                                        placeholder={formatMessage({ id: 'Select Meeting Type' })}
                                        formik={formik}
                                        toolTipText={formatMessage({ id: 'Choose the meeting type' })}
                                        options={MeetingType}
                                        onBlur={formik.handleBlur}

                                    />
                                    <SelectInput
                                        label={formatMessage({ id: 'By Attendance' })}
                                        fieldName='attendance'
                                        placeholder={formatMessage({ id: 'Select Status type' })}
                                        toolTipText={formatMessage({ id: 'Choose the status type' })}
                                        formik={formik}
                                        options={AttendanceType}
                                    />
                                    <TextInput
                                        fieldType='date'
                                        fieldName='date'
                                        formik={formik}
                                        label={formatMessage({ id: 'By Date' })}
                                        placeholder={formatMessage({ id: 'Enter date' })}
                                        toolTipText={formatMessage({
                                            id: 'Select the date for the meeting to be scheduled.',
                                        })}
                                        isWidthNotRequired={true}
                                        isTooltipNotRequired={true}
                                    />
                                </div>
                                {/* Footer */}
                                <div className="d-flex justify-content-center m-md-5 m-0 w-100 w-md-auto px-4" id="fc_footer">
                                    <BasicButton
                                        id="fc-apply"
                                        border="#4776E6"
                                        color="#4776E6"
                                        textColor="#FFFFFF"
                                        // padding="16px 138px" 
                                        buttonText={formatMessage({ id: "Apply filters" })}
                                        minWidth={352}
                                        loading={filterLoading}
                                        disabled={filterLoading || !formik.isValid}
                                        onClick={() => onApplyFilter(formik.values)}
                                        customClass="w-100 mb-md-0 mb-4 custom-button-property"
                                    />
                                </div>
                            </>
                        )
                    }}
                </Formik>
            </div>
        </div>
    );
};

